import IntroHero from "./IntroHero";
import IntroServices from "./IntroServices";
import IntroAbout from "./IntroAbout";
import IntroTestimonials from "./IntroTestimonials";
import IntroFaqs from "./IntroFaqs";
import IntroCtaBanner from "./IntroCtaBanner";
import IntroContactForm from "./IntroContactForm";

const IntroPage = () => {

    return (
        <div>
            <IntroHero></IntroHero>
            <IntroServices></IntroServices>
            <IntroAbout></IntroAbout>
            <IntroTestimonials></IntroTestimonials>
            <IntroFaqs></IntroFaqs>
            <IntroCtaBanner></IntroCtaBanner>
            <IntroContactForm></IntroContactForm>
        </div>
    );
}

export default IntroPage;